import axios from 'axios';
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

import { buildFreightGetHelpFormUrl } from '@shipstation/client-common/components/get-help-modal';
import { getSignInRedirectUrl } from '@shipstation/client-common/services/helpcenter-service';
import { submitZendeskSsoForm } from '@shipstation/client-common/services/zendesk-sso-service';
import { NotificationService, NOTIFICATION_DURATIONS, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';

import { useOpenFreightGetHelpFormMessages } from './use-open-freight-get-help-form-messages';

import type { GetHelpFieldValues, GetHelpSubmission } from '@shipstation/client-common/components/get-help-modal';

export const useOpenFreightGetHelpForm = () => {
  const intl = useIntl();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const openForm = useCallback(
    async (submission: GetHelpSubmission, context: GetHelpFieldValues): Promise<boolean> => {
      setIsSubmitting(true);
      try {
        const formUrl = buildFreightGetHelpFormUrl(submission.reasonCode, context);
        const didOpenViaSso = await submitZendeskSsoForm(getSignInRedirectUrl(formUrl), axios);
        const didOpen = didOpenViaSso || Boolean(window.open(formUrl, '_blank', 'noopener,noreferrer'));

        if (!didOpen) {
          NotificationService.showNotification({
            notificationType: NOTIFICATION_TYPE_ERROR,
            duration: NOTIFICATION_DURATIONS.MEDIUM,
            title: intl.formatMessage(useOpenFreightGetHelpFormMessages.submitErrorTitle),
          });
        }

        return didOpen;
      } finally {
        setIsSubmitting(false);
      }
    },
    [intl],
  );

  return { openForm, isSubmitting };
};
